import { render, staticRenderFns } from "./PayoutsApproved.vue?vue&type=template&id=2f9cdc68&scoped=true&"
import script from "./PayoutsApproved.vue?vue&type=script&lang=js&"
export * from "./PayoutsApproved.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsApproved.vue?vue&type=style&index=0&id=2f9cdc68&lang=scss&scoped=true&"
import style1 from "./PayoutsApproved.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9cdc68",
  null
  
)

export default component.exports